<div class="d-flex">
  <div class="position-relative d-flex">
    <ng-container *ngFor="let color of DEFAULT_COLORS">
      <div
        class="color-circle d-flex justify-content-center align-items-center cursor-pointer rounded-circle me-2"
        [style.background-color]="color"
        (click)="defaultColorSelected(color)"
      >
        <svg
          *ngIf="color == hex.toUpperCase()"
          width="9"
          height="7"
          [stroke]="isLightColor ? 'black' : 'white'"
        >
          <use href="/assets/icons.svg#checkmark" [attr.color]="isLightColor ? 'black' : 'white'" />
        </svg>
      </div>
    </ng-container>

    <div ngbDropdown placement="bottom-left">
      <div class="d-flex justify-content-center align-items-center">
        <div
          ngbDropdownToggle
          class="color-circle d-flex justify-content-center align-items-center cursor-pointer"
          [class.dropdown-toggle-hide]="isDefaultColor || !hex"
        >
          <div
            *ngIf="isDefaultColor || !hex"
            class="d-flex justify-content-center align-items-center rounded-circle"
            style="background-color: #F4F4F4; width: 15px; height: 15px"
          >
            <div style="color: #18A0F8; font-size: 12px; font-weight: 400">
              +
            </div>
          </div>

          <div
            *ngIf="!isDefaultColor && !!hex"
            class="color-circle d-flex justify-content-center align-items-center rounded-circle shadow-sm"
            [style.background-color]="hex"
          >
            <svg width="9" height="7">
              <use href="/assets/icons.svg#checkmark" [attr.color]="isLightColor ? 'black' : 'white'" />
            </svg>
          </div>
        </div>

        <div ngbDropdownMenu style="min-width: 320px; padding: 0px">
          <color-sketch
            [disableAlpha]="true"
            [color]="hex"
            (onChangeComplete)="colorSketchChanged($event)"
          />
        </div>
      </div>
    </div>
  </div>
</div>
